module.exports = __webpack_public_path__ + "static/media/knob.705d2ca2.svg";